function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import Icon from '../icon/Icon';
import Button from '../button/Button';
import LoadingOverlay from '../loadingOverlay/LoadingOverlay';
import Modal from '../modal/Modal';
import { TYPE_SIMPLE } from '../modal/constants';
import { DIALOG_MESSAGE_PROPTYPE, DIALOG_TITLE_PROPTYPE } from './constants';
import { ICON_TYPE_PROP_TYPE } from '../icon/constants';

var HeaderIcon = function HeaderIcon(_ref) {
  var headerIconType = _ref.headerIconType;
  var component = null;

  if (headerIconType) {
    component = React.createElement("div", {
      className: "eds-dialog__icon eds-align--center",
      "data-spec": "eds-dialog__icon"
    }, React.createElement(Icon, {
      type: headerIconType,
      size: "small",
      hasHalo: true
    }));
  }

  return component;
};

var TitleHeader = function TitleHeader(_ref2) {
  var title = _ref2.title;
  var component = null;

  if (title) {
    component = React.createElement("h2", {
      className: " eds-dialog__title eds-l-mar-top-3 eds-l-pad-hor-5 eds-align--center eds-text--center eds-text-hs eds-text-weight--light",
      "data-spec": "eds-dialog__title"
    }, title);
  }

  return component;
};

var MessageParagraph = function MessageParagraph(_ref3) {
  var message = _ref3.message;
  var className = classNames('eds-dialog__message', 'eds-l-mar-top-3', 'eds-l-mar-bot-4', 'eds-text-bm', 'eds-text-color--grey-600', 'eds-text--center');
  var component = null;

  if (message) {
    component = React.createElement("p", {
      className: className
    }, message);
  }

  return component;
};

var ButtonBar = function ButtonBar(_ref4) {
  var primaryIsDisabled = _ref4.primaryIsDisabled,
      primaryType = _ref4.primaryType,
      primaryText = _ref4.primaryText,
      onPrimaryAction = _ref4.onPrimaryAction,
      secondaryIsDisabled = _ref4.secondaryIsDisabled,
      secondaryType = _ref4.secondaryType,
      secondaryText = _ref4.secondaryText,
      onSecondaryAction = _ref4.onSecondaryAction,
      title = _ref4.title;
  var buttonBarClasses = classNames('eds-dialog__button-bar', 'eds-align--center', {
    'eds-dialog__button-bar--with-title': title
  });
  var secondaryButton = null;

  if (secondaryText) {
    secondaryButton = React.createElement("div", {
      className: "eds-dialog__secondary-button"
    }, React.createElement(Button, {
      disabled: secondaryIsDisabled,
      onClick: onSecondaryAction,
      style: secondaryType,
      "data-spec": "eds-dialog__secondary-button"
    }, secondaryText));
  }

  var component = null;

  if (primaryText) {
    component = React.createElement("div", {
      className: buttonBarClasses
    }, secondaryButton, React.createElement("div", {
      className: "eds-dialog__primary-button"
    }, React.createElement(Button, {
      disabled: primaryIsDisabled,
      onClick: onPrimaryAction,
      style: primaryType,
      "data-spec": "eds-dialog__primary-button"
    }, primaryText)));
  }

  return component;
};

var Dialog =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Dialog, _React$PureComponent);

  function Dialog() {
    _classCallCheck(this, Dialog);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dialog).apply(this, arguments));
  }

  _createClass(Dialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          headerIconType = _this$props.headerIconType,
          illustration = _this$props.illustration,
          isLoading = _this$props.isLoading,
          isShown = _this$props.isShown,
          message = _this$props.message,
          onClose = _this$props.onClose,
          onPrimaryAction = _this$props.onPrimaryAction,
          onSecondaryAction = _this$props.onSecondaryAction,
          primaryIsDisabled = _this$props.primaryIsDisabled,
          primaryType = _this$props.primaryType,
          primaryText = _this$props.primaryText,
          secondaryIsDisabled = _this$props.secondaryIsDisabled,
          secondaryType = _this$props.secondaryType,
          secondaryText = _this$props.secondaryText,
          title = _this$props.title;
      var className = classNames('eds-dialog', {
        'eds-dialog--illustration': illustration
      });
      return React.createElement(Modal, {
        type: TYPE_SIMPLE,
        illustration: illustration,
        isShown: isShown,
        onClose: onClose,
        noMinHeight: true,
        dangerouslySetContainerClassName: {
          __className: className
        }
      }, React.createElement(LoadingOverlay, {
        size: "large-chunky",
        isShown: isLoading
      }), React.createElement(HeaderIcon, {
        headerIconType: headerIconType
      }), React.createElement(TitleHeader, {
        title: title
      }), React.createElement(MessageParagraph, {
        message: message,
        title: title
      }), React.createElement(ButtonBar, {
        primaryIsDisabled: primaryIsDisabled,
        primaryType: primaryType,
        primaryText: primaryText,
        onPrimaryAction: onPrimaryAction,
        secondaryIsDisabled: secondaryIsDisabled,
        secondaryType: secondaryType,
        secondaryText: secondaryText,
        onSecondaryAction: onSecondaryAction,
        onClose: onClose,
        title: title
      }));
    }
  }]);

  return Dialog;
}(React.PureComponent);

_defineProperty(Dialog, "propTypes", {
  /**
   * The type of icon displayed in the center of the modal
  */
  headerIconType: ICON_TYPE_PROP_TYPE,

  /**
   * The illustration displayed inside the dialog
  */
  illustration: PropTypes.node,

  /**
   * Is the dialog closable?
  */
  isClosable: PropTypes.bool,

  /**
   * Should the dialog show the loading overlay?
  */
  isLoading: PropTypes.bool,

  /**
   * Is the dialog currently shown?
  */
  isShown: PropTypes.bool,

  /**
   * The message body of a dialog
  */
  message: DIALOG_MESSAGE_PROPTYPE.isRequired,

  /**
  * A function with the desired behavior on close
  */
  onClose: PropTypes.func,

  /**
   * The function that should be triggered on primary button click
  */
  onPrimaryAction: PropTypes.func,

  /**
   * The function that should be triggered on secondary button click
  */
  onSecondaryAction: PropTypes.func,

  /**
   * Whether the primary button should be disabled
  */
  primaryIsDisabled: PropTypes.bool,

  /**
   * The text that should be shown across the primary button
  */
  primaryText: EBPropTypes.translation,

  /**
   * The type of button that should be shown for primary button
  */
  primaryType: PropTypes.string,

  /**
   * Whether the secondary button should be disabled
  */
  secondaryIsDisabled: PropTypes.bool,

  /**
   * The text that should be shown across the secondary button
  */
  secondaryText: EBPropTypes.translation,

  /**
   * The type of button that should be shown for secondary button
  */
  secondaryType: PropTypes.string,

  /**
   * The title on top of the message
  */
  title: DIALOG_TITLE_PROPTYPE
});

export { Dialog as default };